module.exports = __webpack_public_path__ + "static/obog-9d3957b824cebcaa8f86f9cc82fab2f0.jpg";